import axios from "../../helpers/httpClient";
import { updateAmountWithCurrency } from './componentsActions';

export default {
    resetStatusApiCaja: async ({ commit }) => {
        commit('SET_STATUS_API_CAJA', { message: "", success: "" })
    },
    resetStatusApiCodigoC: async ({ commit }) => {
        commit('SET_STATUS_API_CODIGO_C', { message: "", success: "" })
    },
    //ACTION CAJA
    crearCajaGestion: async ({ commit, dispatch, state }, caja) => {
        const stateData = state.cajas
        const stateNum = state.ultimoCodigoContableNumCaja

        try {
            // Start loader
            commit('SET_LOADER', true);

            const cajaGestion = await axios.post(`/information/private/management/crearCajaGestion`, caja)

            // Stop Loader
            commit('SET_LOADER', false);

            if (cajaGestion.status === 200) {

                stateData.push(cajaGestion.data.data)

                const obj = {
                    array: stateData,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CAJAS', newStateData);
                commit('SET_CAJAS_FILTROS', newStateData);

                commit('SET_CAJAS_EXPORT', newStateData);
                commit('SET_CAJAS_FILTERS_EXPORT', newStateData);

                commit('SET_ULTIMO_CODIGO_CONTABLE_NUM_CAJA', Number(stateNum) + 1)
                commit(
                    'SET_ULTIMO_CODIGO_CONTABLE_CAJA',
                    `1.1.1.01.${((Number(stateNum) + 1) >= 10)
                        ? (Number(stateNum) + 1)
                        : `0${(Number(stateNum) + 1)}`
                    }`
                )

                dispatch('activeMessageCorrect', cajaGestion.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editarCajaVuex: async ({ commit, dispatch, state }, codigo) => {
        const stateData = state.cajas
        const stateCc = state.codigosContables

        try {
            // Start loader
            commit('SET_LOADER', true);

            const caja = await axios.post(`/information/private/management/editarCaja`, {
                ...codigo,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (caja.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_caja === caja.data.data[0].Id_caja) {
                        Object.assign(stateData[index], caja.data.data[0])
                    }
                })

                stateCc.forEach((data, index) => {
                    if (data.Codigo === caja.data.data[0].Cc_caja) {
                        stateCc[index].Referencia = codigo.nombre
                    }
                })

                const obj = {
                    array: stateData,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CODIGOS_CONTABLES', stateCc);
                commit('SET_CODIGOS_CONTABLES_FILTROS', stateCc);
                commit('SET_CAJAS', newStateData);
                commit('SET_CAJAS_FILTROS', newStateData);
                
                commit('SET_CAJAS_EXPORT', newStateData);
                commit('SET_CAJAS_FILTERS_EXPORT', newStateData);

                dispatch('requestMovimientosCajas')
                dispatch('activeMessageCorrect', caja.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    eliminarCajaVuex: async ({ commit, dispatch, state }, codigo) => {
        const stateDataCaja = state.cajas
        const stateDataCc = state.codigosContables

        try {
            // Start loader
            commit('SET_LOADER', true);

            const cajaGestion = await axios.post(`/information/private/management/eliminarCaja`, {
                ...codigo,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (cajaGestion.status === 200) {
                if (cajaGestion.data.message === 'Error movimientos existentes') {
                    dispatch('activeMessageError', cajaGestion.data.message)
                } else {
                    stateDataCaja.forEach((data, index) => {
                        if (data.Id_caja === codigo.idCodigo) {
                            stateDataCaja.splice(index, 1)
                        }
                    })
    
                    stateDataCc.forEach((data, index) => {
                        if (data.Codigo === codigo.codigo) {
                            stateDataCc.splice(index, 1)
                        }
                    })

                    const obj = {
                        array: stateDataCaja,
                        property: 'monto_existente'
                    };

                    let newStateData = await dispatch('updateAmountWithCurrency', obj);
    
                    commit('SET_CAJAS', newStateData);
                    commit('SET_CAJAS_FILTROS', newStateData);
                    
                    commit('SET_CAJAS_EXPORT', newStateData);
                    commit('SET_CAJAS_FILTERS_EXPORT', newStateData);

                    commit('SET_CODIGOS_CONTABLES', stateDataCc);
                    commit('SET_CODIGOS_CONTABLES_FILTROS', stateDataCc);

                    dispatch('activeMessageCorrect', cajaGestion.data.message)
                }

                return cajaGestion
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    requestCajas: async ({ commit, state, dispatch }, obj) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const cajas = await axios.get(`/information/private/management/consultaDatosCaja`, {
                params: {
                    perPage: (obj) ? obj.perPage : 40,
                    currentPage: (obj) ? obj.currentPage : 1,
                    dataFilter: (obj) ? obj.dataFilter : {}
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (cajas.status === 200) {
                const obj = {
                    array: cajas.data.cajaGestion,
                    property: 'monto_existente'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CAJAS', newStateData);
                commit('SET_CAJAS_FILTROS', newStateData);
                
                commit('SET_CAJAS_EXPORT', newStateData);
                commit('SET_CAJAS_FILTERS_EXPORT', newStateData);
                
                commit('SET_TOTAL_CAJAS', cajas.data.totalCoincidences);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    requestCaja: async ({ commit, state, dispatch }, id) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const cajas = await axios.get(`/information/private/management/consultaCaja`, {
                params: {id}
            },{
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (cajas.status === 200) {
                return cajas.data.cajaGestion;
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    addCajasImport: async ({ commit, dispatch, state }, allCajas) => {
        const stateData = state.cajas

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newCajas = await axios.post(`/information/private/management/addCajasImport`, {
                allCajas,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newCajas.status === 200) {
                stateData.push(newCajas.data.data)

                const obj = {
                    array: stateData,
                    property: 'monto_existente'
                };
                await dispatch('updateAmountWithCurrency', obj);

                commit('SET_CAJAS', stateData);
                commit('SET_CAJAS_FILTROS', stateData);
                
                commit('SET_CAJAS_EXPORT', stateData);
                commit('SET_CAJAS_FILTERS_EXPORT', stateData);
                
                dispatch('activeMessageCorrect', newCajas.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    //ACTION MOVIMIENTOS CAJAS
    requestMovimientosCajas: async ({ commit, state, dispatch }, obj) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const movimientos = await axios.get(`/information/private/management/consultaDatosMovimientoCaja`, {
                params: {
                    perPage: (obj) ? obj.perPage : 40,
                    currentPage: (obj) ? obj.currentPage : 1,
                    dataFilter: (obj) ? obj.dataFilter : {}
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientos.status === 200) {
                const obj = {
                    array: movimientos.data.movimientoCaja,
                    property: 'Cantidad'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_MOVIMIENTOS_CAJAS', newStateData);
                commit('SET_MOVIMIENTOS_CAJAS_FILTROS', newStateData);
                
                commit('SET_MOVIMIENTOS_CAJAS_EXPORT', newStateData);
                commit('SET_MOVIMIENTOS_CAJAS_FILTERS_EXPORT', newStateData);

                commit('SET_TOTAL_MOVIMIENTOS_CAJA', movimientos.data.totalCoincidences);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getTotalMovimientosCajas: async ({ commit, state, dispatch }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const movimientos = await axios.get(`/information/private/management/getTotalMovimientosCajas`)

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientos.status === 200) {
                commit('SET_TOTAL_MOVIMIENTOS_CAJA', movimientos.data.movimientoCaja);
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addMovimientosCajas: async ({ commit, state }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const movimiento = await axios.post(`/information/private/management/crearMovimientoCaja`, {
                arregloInformacion: this.arregloTodosLosMovimientos,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimiento.status === 200) {

            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }

    },
    requestMovimientosOtros: async ({ commit, state, dispatch }) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const otros = await axios.get(`/information/private/management/consultaDatosMovimientoOtros`, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (otros.status === 200) {

                const obj = {
                    array: otros.data.movimientoOtros,
                    property: 'Cantidad'
                };
                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_MOVIMIENTOS_OTROS', newStateData);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    filterByCheckout: async ({ state, dispatch, commit }, cajaSeleccionada1, cajaSeleccionada2) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let filtradoCajaGestion = await axios.get(`/information/private/management/filtradoCajaGestion`, {
                params: {
                    codigo: cajaSeleccionada1,
                    nombre: cajaSeleccionada2
                }
            },

                { headers: { "Content-Type": "application/json" } }
            );

            // Stop Loader
            commit('SET_LOADER', false);

            return filtradoCajaGestion;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    createCheckoutMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movimientosCaja = await axios.post(`/information/private/management/crearMovimientoCaja`, {
                arregloInformacion: arregloTodosLosMovimientos,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientosCaja.status === 200) {
                dispatch('activeMessageCorrect', movimientosCaja.data.message)
                return 'ok'
            }

            return movimientosCaja;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    editCheckoutMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movimientosCaja = await axios.post(`/information/private/management/editarMovimientoCaja`, {
                arregloInformacion: arregloTodosLosMovimientos,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movimientosCaja.status === 200) {
                dispatch('activeMessageCorrect', movimientosCaja.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    deleteCheckoutMovement: async ({ state, dispatch, commit }, relacionMovimiento) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movimientosEliminados = await axios.post(`/information/private/management/eliminarMovimientosCaja`, {
                codigoRelacion: relacionMovimiento,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            return movimientosEliminados;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    addMovementsCajaImport: async ({ state, dispatch, commit }, dataArray) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let movements = await axios.post(`/information/private/management/addMovementsImport`, {
                dataArray,
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (movements.status === 200) {
                dispatch('activeMessageCorrect', movements.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}

// export default {
//     resetStatusApiCaja: async ({ commit }) => {
//         commit('SET_STATUS_API_CAJA', { message: "", success: "" })
//     },
//     resetStatusApiCodigoC: async ({ commit }) => {
//         commit('SET_STATUS_API_CODIGO_C', { message: "", success: "" })
//     },
//     //ACTION CAJA
//     crearCajaGestion: async ({ commit, dispatch, state }, caja) => {
//         const stateData = state.cajas
//         const stateNum = state.ultimoCodigoContableNumCaja

//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const cajaGestion = await axios.post(`/information/private/management/crearCajaGestion`, caja)

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (cajaGestion.status === 200) {

//                 stateData.push(cajaGestion.data.data)

//                 commit('SET_CAJAS', stateData);
//                 commit('SET_CAJAS_FILTROS', stateData);
//                 commit('SET_ULTIMO_CODIGO_CONTABLE_NUM_CAJA', Number(stateNum) + 1)
//                 commit(
//                     'SET_ULTIMO_CODIGO_CONTABLE_CAJA',
//                     `1.1.1.01.${((Number(stateNum) + 1) >= 10)
//                         ? (Number(stateNum) + 1)
//                         : `0${(Number(stateNum) + 1)}`
//                     }`
//                 )

//                 dispatch('activeMessageCorrect', cajaGestion.data.message)
//                 return 'ok'
//             }
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     editarCajaVuex: async ({ commit, dispatch, state }, codigo) => {
//         const stateData = state.cajas
//         const stateCc = state.codigosContables

//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const caja = await axios.post(`/information/private/management/editarCaja`, {
//                 ...codigo,
//             })

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (caja.status === 200) {

//                 stateData.forEach((data, index) => {
//                     if (data.Id_caja === caja.data.data[0].Id_caja) {
//                         Object.assign(stateData[index], caja.data.data[0])
//                     }
//                 })

//                 stateCc.forEach((data, index) => {
//                     if (data.Codigo === caja.data.data[0].Cc_caja) {
//                         stateCc[index].Referencia = codigo.nombre
//                     }
//                 })

//                 commit('SET_CODIGOS_CONTABLES', stateCc);
//                 commit('SET_CODIGOS_CONTABLES_FILTROS', stateCc);
//                 commit('SET_CAJAS', stateData);
//                 commit('SET_CAJAS_FILTROS', stateData);

//                 dispatch('requestMovimientosCajas')
//                 dispatch('activeMessageCorrect', caja.data.message)
//                 return 'ok'

//             }

//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     eliminarCajaVuex: async ({ commit, dispatch, state }, codigo) => {
//         const stateDataCaja = state.cajas
//         const stateDataCc = state.codigosContables

//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const cajaGestion = await axios.post(`/information/private/management/eliminarCaja`, {
//                 ...codigo,
//             })

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (cajaGestion.status === 200) {

//                 stateDataCaja.forEach((data, index) => {
//                     if (data.Id_caja === codigo.idCodigo) {
//                         stateDataCaja.splice(index, 1)
//                     }
//                 })

//                 stateDataCc.forEach((data, index) => {
//                     if (data.Codigo === codigo.codigo) {
//                         stateDataCc.splice(index, 1)
//                     }
//                 })

//                 commit('SET_CAJAS', stateDataCaja);
//                 commit('SET_CAJAS_FILTROS', stateDataCaja);
//                 commit('SET_CODIGOS_CONTABLES', stateDataCc);
//                 commit('SET_CODIGOS_CONTABLES_FILTROS', stateDataCc);

//                 dispatch('activeMessageCorrect', cajaGestion.data.message)
//                 return cajaGestion
//             }

//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     requestCajas: async ({ commit, state, dispatch }, obj) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const cajas = await axios.get(`/information/private/management/consultaDatosCaja`, {
//                 params: {
//                     perPage: (obj) ? obj.perPage : 40,
//                     currentPage: (obj) ? obj.currentPage : 1
//                 }
//             }, {
//                 headers: { 'Content-Type': 'application/json' }
//             });

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (cajas.status === 200) {
//                 commit('SET_CAJAS', cajas.data.cajaGestion);
//                 commit('SET_CAJAS_FILTROS', cajas.data.cajaGestion);
//             }

//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },

//     //ACTION MOVIMIENTOS CAJAS
//     requestMovimientosCajas: async ({ commit, state, dispatch }, obj) => {

//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const movimientos = await axios.get(`/information/private/management/consultaDatosMovimientoCaja`, {
//                 params: {
//                     perPage: (obj) ? obj.perPage : 40,
//                     currentPage: (obj) ? obj.currentPage : 1
//                 }
//             }, {
//                 headers: { 'Content-Type': 'application/json' }
//             })

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (movimientos.status === 200) {
//                 commit('SET_MOVIMIENTOS_CAJAS', movimientos.data.movimientoCaja);
//                 commit('SET_MOVIMIENTOS_CAJAS_FILTROS', movimientos.data.movimientoCaja);
//             }

//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },

//     getTotalMovimientosCajas: async ({ commit, state, dispatch }) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const movimientos = await axios.get(`/information/private/management/getTotalMovimientosCajas`, {
//                 params: {
//                 }
//             }, {
//                 headers: { 'Content-Type': 'application/json' }
//             })

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (movimientos.status === 200) {
//                 commit('SET_TOTAL_MOVIMIENTOS_CAJA', movimientos.data.movimientoCaja);
//             }

//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },

//     addMovimientosCajas: async ({ commit, state }) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const movimiento = await axios.post(`/information/private/management/crearMovimientoCaja`, {
//                 arregloInformacion: this.arregloTodosLosMovimientos,
//             })

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (movimiento.status === 200) {

//             }
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }

//     },
//     requestMovimientosOtros: async ({ commit, state, dispatch }) => {

//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             const otros = await axios.get(`/information/private/management/consultaDatosMovimientoOtros`, {
//                 params: {
//                 }
//             }, {
//                 headers: { 'Content-Type': 'application/json' }
//             });

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (otros.status === 200) {
//                 commit('SET_MOVIMIENTOS_OTROS', otros.data.movimientoOtros);
//                 // commit('SET_MOVIENTOS_BANCOS_FILTROS', otros.data.movimientoOtros);
//             }
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     filterByCheckout: async ({ state, dispatch, commit }, cajaSeleccionada1, cajaSeleccionada2) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             let filtradoCajaGestion = await axios.get(`/information/private/management/filtradoCajaGestion`, {
//                 params: {
//                     codigo: cajaSeleccionada1,
//                     nombre: cajaSeleccionada2
//                 }
//             },

//                 { headers: { "Content-Type": "application/json" } }
//             );

//             // Stop Loader
//             commit('SET_LOADER', false);

//             return filtradoCajaGestion;
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     createCheckoutMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             let movimientosCaja = await axios.post(`/information/private/management/crearMovimientoCaja`, {
//                 arregloInformacion: arregloTodosLosMovimientos,
//             });

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (movimientosCaja.status === 200) {
//                 dispatch('activeMessageCorrect', movimientosCaja.data.message)
//                 return 'ok'
//             }

//             return movimientosCaja;
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     editCheckoutMovement: async ({ state, dispatch, commit }, arregloTodosLosMovimientos) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             let movimientosCaja = await axios.post(`/information/private/management/editarMovimientoCaja`, {
//                 arregloInformacion: arregloTodosLosMovimientos,
//             });

//             // Stop Loader
//             commit('SET_LOADER', false);

//             if (movimientosCaja.status === 200) {
//                 dispatch('activeMessageCorrect', movimientosCaja.data.message)
//                 return 'ok'
//             }
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     },
//     deleteCheckoutMovement: async ({ state, dispatch, commit }, relacionMovimiento) => {
//         try {
//             // Start loader
//             commit('SET_LOADER', true);

//             let movimientosEliminados = await axios.post(`/information/private/management/eliminarMovimientosCaja`, {
//                 codigoRelacion: relacionMovimiento,
//             });

//             // Stop Loader
//             commit('SET_LOADER', false);

//             return movimientosEliminados;
//         } catch (error) {
//             // Stop Loader
//             commit('SET_LOADER', false);

//             console.log(error)
//             if (error?.response) {
//                 console.log(error?.response)
//                 dispatch('activeMessageError', (error.response !== undefined)
//                     ? error?.response?.data?.message || error?.response?.data?.msg
//                     : 'ERROR'
//                 )
//             } else {
//                 dispatch('activeMessageError', 'ERROR')
//                 console.log(error)
//             }
//             return
//         }
//     }
// }